import { format } from 'date-fns';
import { DateFormats } from 'constants/dateFormats';


export const parseISODateFormat = (date: Date): string => (
  format(date, DateFormats.isoDate)
);
